import {componentLoader, componentConfig} from "../../lib/component_initializer";
import {PaneSlides} from "./pane_slides"

export const paneSlidesLoader = function (options = {}) {
    componentLoader(componentConfig(PaneSlides, PaneSlides.config.componentTypeKey, PaneSlides.config.baseHtmlClass), options);
};

